module.exports = __webpack_public_path__ + "static/media/puerta33.86b596b3.png";